import { JSX } from 'preact'
import { useRef } from 'preact/hooks'
import classnames from 'classnames'
import { ActionType, BlockType, TBlockProps } from '@gsc/types'
import genUID from '../../../shared/uid'
import { previewProps } from '../../preview'
import { Tooltip } from '../Notifications/Tooltip'
import { useComponentStyle } from '../Style'
import { useActions } from '../useActions'
import { Icon } from './Icon'
import { Text } from './Text'

export const Button = ({ label, actions = [], icon, ...props }: TBlockProps<BlockType.Button>): JSX.Element => {
  const { current: origin } = useRef(genUID())
  const { classes } = useComponentStyle('button', props)
  const processActions = useActions()

  const type = actions.some(a => a.type === ActionType.Submit) ? 'submit' : 'button'
  const className = classnames(classes)

  const handleClick = () => {
    const labeledActions = actions.map(a => (a.type === ActionType.OpenUrl && !a.label ? { ...a, label } : a))
    return processActions(labeledActions, origin)
  }

  return (
    <button type={type} className={className} onClick={handleClick} {...previewProps(BlockType.Button, props.id)}>
      {icon && <Icon className="button-icon" src={icon.src} />}
      {label && <Text className="button-text" tag="span" text={label} />}
      <Tooltip name={origin} />
    </button>
  )
}
